/**
 * @generated SignedSource<<9489ff9880b7f9ac2c32462af6f4726c>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type NotBillableReason = "ADMINISTRATIVE" | "INCOMPLETE_CONSULTATION" | "OTHER_REASON";
export type Service = "ADMINISTRATIVE_REQUEST" | "CONSULTATION" | "EMERGENCY_LINE" | "KIDS_LINE" | "MEDGATE_CONNECT" | "PREVENTION_ASSESSMENT" | "PSYCHOSOCIAL" | "STUDY_CALL" | "TELE_GENERAL_PRACTITIONER";
import { FragmentRefs } from "relay-runtime";
export type deBillingDialogContentBillingFragment$data = {
  readonly billingAttribute: {
    readonly id: string;
    readonly isNotBillable: boolean;
    readonly isVisualSymptomExamination: boolean | null;
    readonly notBillableReason: NotBillableReason | null;
    readonly reason: string | null;
  } | null;
  readonly id: string;
  readonly service: Service;
  readonly " $fragmentType": "deBillingDialogContentBillingFragment";
};
export type deBillingDialogContentBillingFragment$key = {
  readonly " $data"?: deBillingDialogContentBillingFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"deBillingDialogContentBillingFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "deBillingDialogContentBillingFragment",
  "selections": [
    (v0/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "service",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "BillingAttribute",
      "kind": "LinkedField",
      "name": "billingAttribute",
      "plural": false,
      "selections": [
        (v0/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isNotBillable",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "notBillableReason",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "reason",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isVisualSymptomExamination",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Appointment",
  "abstractKey": null
};
})();

(node as any).hash = "3cd6424102d142b044fb0f72563ebfab";

export default node;
